import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle,
  Modal,
  ModalBody,
  Label,
} from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility';
import { AvField, AvForm } from "availity-reactstrap-validation";
import Loader from "../../components/Loader";
import DeleteModal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { get, post, put, upload } from '../../helpers/api_helper'
import { toast } from 'react-toastify';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';


const Moods = props => {
  const { user } = props;
  const [isAddForm, setIsAddForm] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [image, setImage] = useState(null);
  const [audio, setAudio] = useState(null);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [cats, setCats] = useState([]);
  const [selectedLang, setSelectedLang] = useState([]);

  useEffect(() => {
    if (user?.token) {
      getCats();
      getData();
    }
  }, [user]);

  useEffect(() => {
    if (!isAddForm) {
      setCurrentData(null);
      setSelectedLang([]);
    }
  }, [isAddForm]);

  const getCats = () => {
    get("/harmony/cat?lang=en", { token: user?.token })
      .then(res => {
        if (res.statusCode == 200)
          setCats(res?.data);
      })
  }

  const getData = () => {
    if (!loading) {
      setLoading(true);
      get("/harmony/sound/list", { token: user?.token })
        .then(res => {
          setLoading(false);
          if (res?.statusCode == 200) {
            res?.data?.map((item) => {
              item.isPlaying = false;
            })
            setData(res?.data);
          } else
            toast.error(res?.error);
        })
        .catch(err => {
          toast.error('Something Went Wrong!');
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    setColumns([
      {
        name: "Position",
        cell: (row, index) => <>
          <Draggable key={row._id} draggableId={row._id} index={index}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <i className="mdi mdi-menu" style={{ fontSize: 20, color: Utils.themeColor }}></i>
              </div>
            )}
          </Draggable>
        </>,
        maxWidth: '50px'
      },
      {
        name: 'Image',
        cell: (row) =>
          <img
            src={row?.image}
            alt="SVG sound"
            httpRequestWithCredentials={false}
            renumerateIRIElements={false}
            width="35"
          />,
        maxWidth: '100px'
      },
      {
        name: 'Title',
        selector: row => row.title,
      },
      {
        name: 'Category',
        selector: row => row.category[0]?.title,
        maxWidth: '200px'
      },
      {
        name: 'Audio',
        cell: (row, index) => <>
          <span style={{ border: "1px solid " + Utils.themeColor, borderRadius: 70, width: 30, height: 30, justifyContent: 'center', alignItems: 'center', display: 'flex', cursor: 'pointer' }}
            onClick={() => handleToggleAudio(row, index)}
          >
            {row?.isPlaying ?
              <i className="mdi mdi-pause" style={{ fontSize: 20, color: Utils.themeColor, marginTop: 3 }}></i>
              :
              <i className="mdi mdi-play" style={{ fontSize: 20, color: Utils.themeColor, marginTop: 3 }}></i>
            }
          </span>
          <span style={{ border: "1px solid " + Utils.themeColor, borderRadius: 70, marginLeft: 5, width: 30, height: 30, justifyContent: 'center', alignItems: 'center', display: 'flex', cursor: 'pointer' }}
            onClick={() => window.open(row.audio)}
          >
            <i className="mdi mdi-download" style={{ fontSize: 20, color: Utils.themeColor, marginTop: 5 }}></i>
          </span>
        </>,
        selector: row => row.audio,
        maxWidth: '100px'
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row)}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
        maxWidth: '110px'
      },
      user?.role == 'Admin' &&
      {
        cell: (row) => <>
          <Button onClick={() => handlePaid(row)}
            title={"Paid"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className={row?.isPaid ? "mdi mdi-currency-usd" : "mdi mdi-currency-usd-off"} style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleUpdateProj(row)}
            title={"Edit"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleDeleteProj(row)}
            title={"Delete"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        maxWidth: '150px'
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  const handleToggleAudio = (row, index) => {
    setCurrentAudio(row?.audio);
    console.log('playing', row, index);
    const audioElement = document.getElementById('audio');
    if (!audioElement) return;
    if (row?.isPlaying) {
      audioElement.pause();
      let dat = Object.assign([], data);
      dat[index].isPlaying = false;
      setData(dat);
    } else {
      audioElement.pause();
      setTimeout(() => {
        audioElement.play();
        let dat = Object.assign([], data);
        dat.map((item, inde) => {
          if (inde == index)
            item.isPlaying = true;
          else
            item.isPlaying = false;
        })
        setData(dat);
      }, 500);
    }
  }

  const handleValidSubmit = async (e, v) => {
    console.log('values', v);
    let body = {
      ...v,
      alterLang: selectedLang,
      token: user?.token
    }
    if (currentData) {
      setLoading(true);
      body = { ...body, soundId: currentData?._id };
      if (image.substring(0, 4) == 'blob') {
        const obj = await urltoFile(image, new Date().getTime() + '.svg', 'image/svg');
        // const temp = await resizeFile(obj);
        const form = new FormData();
        form.append("image", obj);
        const imageRes = await upload("/harmony/image_upload", form);
        body = { ...body, image: imageRes?.data };
      }
      if (audio.substring(0, 4) == 'blob') {
        const obj = await urltoFile(audio, new Date().getTime() + '.mp3', 'audio/mpeg');
        // const temp = await resizeFile(obj);
        const form = new FormData();
        form.append("image", obj);
        const imageRes = await upload("/harmony/image_upload", form);
        body = { ...body, audio: imageRes?.data };
      }
      put("/harmony/sound/update", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch(err => {
          toast.error(err);
          setLoading(false);
        })
    } else {
      setLoading(true);
      if (image.substring(0, 4) == 'blob') {
        const obj = await urltoFile(image, new Date().getTime() + '.svg', 'image/svg');
        // const temp = await resizeFile(obj);
        const form = new FormData();
        form.append("image", obj);
        const imageRes = await upload("/harmony/image_upload", form);
        body = { ...body, image: imageRes?.data };
      }
      if (audio.substring(0, 4) == 'blob') {
        const obj = await urltoFile(audio, new Date().getTime() + '.mp3', 'audio/mpeg');
        // const temp = await resizeFile(obj);
        const form = new FormData();
        form.append("image", obj);
        const imageRes = await upload("/harmony/image_upload", form);
        body = { ...body, audio: imageRes?.data };
      }
      post("/harmony/sound/add", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch(err => {
          toast.error(err);
          setLoading(false);
        })
    }
  }

  const handleUpdateProj = (row) => {
    setImage(row?.image);
    setAudio(row?.audio);
    setCurrentData(row);
    if (row?.alterLang?.length)
      setSelectedLang(row?.alterLang);
    setIsAddForm(true);
  }

  const handleUpdateStatus = (row) => {
    setCurrentData({ ...row, actionType: 'Status' });
    setDeleteModal(true);
  }

  const handleDeleteProj = (proj) => {
    setCurrentData(proj);
    setDeleteModal(true);
  }

  const onStatus = () => {
    // console.log('status', currentModalData);
    setLoading(true);
    let body = {
      soundId: currentData?._id,
      isActive: !currentData?.isActive,
      token: user?.token
    }
    let url = `/harmony/sound/update`;
    put(url, body)
      .then(json => {
        console.log('response from delete user', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
        console.error('error while deleting user', error);
      })
  }

  const onDelete = () => {
    setLoading(true);
    let body = {
      soundId: currentData?._id,
      token: user?.token
    }
    let url = `/harmony/sound/update`;
    if (currentData?.actionType == 'Paid') {
      body = { ...body, isPaid: !currentData?.isPaid };
    } else {
      body = { ...body, isDeleted: true };
    }
    put(url, body)
      .then(json => {
        console.log('response from delete user', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
        console.error('error while deleting user', error);
      })
  }

  const urltoFile = (url, filename, mimeType) => {
    return (fetch(url)
      .then(function (res) { return res.arrayBuffer(); })
      .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
  }

  const handleDragEnd = (result) => {
    console.log('dragging item', result);
    // Handle the drag-and-drop logic here
    if (!result.destination) return; // Item was dropped outside the list
    const items = [...data];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let ids = [], position = [];
    items.forEach((item, index) => {
      ids.push(item?._id);
      position.push(index);
    })
    let body = {
      ids,
      position,
      token: user?.token
    }
    put("/harmony/sound/position", body)
      .then(res => {
        // if (res?.statusCode == 200)
        setData(items);
      })
  };

  const handlePaid = (row) => {
    setCurrentData({ ...row, actionType: "Paid" });
    setDeleteModal(true);
  }

  const handleSelectLang = (code, lang) => {
    let temp = Object.assign([], selectedLang);
    let already = temp.findIndex(x => x.code == code);
    if (already == -1) {
      temp.push({ code: code, title: "", lang });
    } else {
      temp.splice(already, 1);
    }
    // console.log("temp", temp);
    setSelectedLang(temp);
  }

  const handleAlterTitle = (index, key, val) => {
    let temp = Object.assign([], selectedLang);
    temp[index][key] = val;
    setSelectedLang(temp);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Harmony Sounds" />
        <Modal isOpen={isAddForm} centered={true}>
          <ModalBody className="py-3 px-5">
            <h5 className="text-black font-size-20">{currentData ? `Update Sound!` : `Add New Sound!`}</h5>
            <div className="p-2">
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v, 'bank')
                }}
              >
                <Row>
                  <Col lg={12} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="catId"
                        label="Sound Category *"
                        className="form-control"
                        type="select"
                        required
                        value={currentData?.catId}
                      >
                        <option value="">Select Category</option>
                        {cats?.map((item) => (
                          <option value={item?._id}>{item?.title}</option>
                        ))}
                      </AvField>
                    </div>
                  </Col>

                  <Col lg={12} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="file_image"
                        label="SVG *"
                        className="form-control"
                        type="file"
                        accept="image/svg+xml"
                        onChange={(e) => setImage(URL.createObjectURL(e.target.files[0]))}
                        required={data ? false : true}
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="file_audio"
                        label="Audio *"
                        className="form-control"
                        type="file"
                        accept="audio/mpeg"
                        onChange={(e) => setAudio(URL.createObjectURL(e.target.files[0]))}
                        required={data ? false : true}
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="title"
                        label="Title *"
                        className="form-control"
                        placeholder="Enter sound title"
                        type="text"
                        required
                        value={currentData?.title}
                      />
                    </div>
                  </Col>
                </Row>
                <Label>Alternative Languages</Label>
                <Row>
                  <div className='lang-checks mb-3'>
                    {user?.languages?.map((item) => (
                      <div className='check-group'>
                        <label for={item?.title} class="container">
                          {item?.title}
                          <input type="checkbox" name={item?.title} id={item?.title} checked={selectedLang.findIndex(x => x?.code == item?.code) != -1} onChange={(e) => handleSelectLang(item?.code, item?.title)} />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    ))}
                  </div>
                  {selectedLang?.map((item, index) => (
                    <Row>
                      <Col md={12}>
                        <div className="mb-3">
                          <AvField
                            name={"title" + item?.lang}
                            label={"Title in " + item?.lang}
                            className="form-control"
                            placeholder={"Enter title in " + item?.lang}
                            type="text"
                            onChange={(e) => handleAlterTitle(index, "title", e.target.value)}
                            required
                            value={item?.title}
                          />
                        </div>
                      </Col>
                    </Row>
                  ))}
                </Row>
                <div className="mt-4">
                  <Row>
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                        onClick={() => { setIsAddForm(false); }}
                        type="reset"
                      >
                        Cancel
                      </button>
                    </Col>
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        type="submit"
                        style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                      >
                        {currentData ? 'Update' : 'Add'}
                      </button>
                    </Col>
                  </Row>
                </div>
              </AvForm>
            </div>
          </ModalBody>
        </Modal>
        <Card>
          <CardBody>
            <Row>
              <DeleteModal
                show={deleteModal}
                onDeleteClick={() => currentData?.actionType == 'Status' ? onStatus() : onDelete()}
                onCloseClick={() => setDeleteModal(false)}
                actionType={currentData?.actionType}
                data={currentData}
              />
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                      <div>
                        <CardTitle className="h4">Sounds</CardTitle>
                        <CardSubtitle className="mb-3">
                          All sound you have added before.
                        </CardSubtitle>
                      </div>
                      {user?.role == 'Admin' &&
                        <div className="text-center" style={{ marginLeft: 'auto' }}>
                          <Button style={{ backgroundColor: Utils.themeColor, border: 'none' }} onClick={() => setIsAddForm(true)}>
                            Add
                          </Button>
                        </div>
                      }
                    </div>
                    <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable droppableId="table">
                        {(provided) => (
                          <div {...provided.droppableProps} ref={provided.innerRef}>
                            <DataTable
                              columns={columns}
                              data={data}
                              pagination
                              customStyles={{
                                headCells: {
                                  style: {
                                    color: 'black',
                                    fontWeight: 'bold',
                                    fontSize: 15,
                                    maxWidth: 80
                                  },
                                },
                                cells: {
                                  style: {
                                    maxWidth: 50
                                  }
                                }
                              }}
                              conditionalRowStyles={[{
                                when: row => row?.seen?.length < 1,
                                style: { backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, color: 'white', cursor: 'pointer' },
                              }]}
                            // onRowClicked={(r, e) => seenNoti(r)}
                            />
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <audio id="audio" src={currentAudio} />
      </div>
    </React.Fragment>
  )
}


const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, {})(Moods)
)